"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountSelectionState = /** @class */ (function () {
    function AccountSelectionState() {
        this.disabledButton = true;
    }
    return AccountSelectionState;
}());
exports.default = AccountSelectionState;
//# sourceMappingURL=AccountSelectionState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/AccountSelection/AccountSelectionState.js
// module id = 1514
// module chunks = 8